import Skeleton from "react-loading-skeleton";
import { useAppointmentReasons } from "../../../queries";

/** Cancellation form for an active appointment. */
export function AppointmentCancellationModal({
  isOpen,
  reason,
  reasons: propReasons,
  isSubmitting,
  onReasonChange,
  onClose,
  onSubmit,
}) {
  const { data: fetchedReasons, isLoading: isLoadingReasons } = useAppointmentReasons(
    "cancel",
    {
      enabled: Boolean(isOpen),
      staleTime: 5 * 60 * 1000,
      gcTime: 5 * 60 * 1000,
    }
  );

  if (!isOpen) return null;

  const reasons =
    propReasons && propReasons.length > 0
      ? propReasons
      : fetchedReasons ?? [];
  const showSkeleton = isLoadingReasons && (!propReasons || propReasons.length === 0);

  return (
    <div className="modal CancelAppointmnetModal" onClick={onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <button
            aria-label="Close appointment cancellation"
            className="CloseButton"
            onClick={onClose}
            type="button"
          />
          <h3>Cancel appointment</h3>
          <p>Are you sure you want to cancel this appointment?</p>
        </div>

        <div className="modal-body">
          <ul className="AddIndicatorList">
            <li>
              <label htmlFor="appointment-cancellation-reason">
                What is reason of appointment cancellation?
              </label>
              {showSkeleton ? (
                <div
                  className="SkelWrapper"
                  data-testid="cancellation-reason-skeleton"
                  style={{ marginTop: "8px", marginBottom: "8px" }}
                >
                  <Skeleton height={40} borderRadius={8} baseColor="#cfd5f9" />
                </div>
              ) : (
                <div className="CustomSelect">
                  <select
                    id="appointment-cancellation-reason"
                    aria-label="Cancellation reason"
                    value={reason ?? ""}
                    onChange={(event) => onReasonChange(event.target.value)}
                  >
                    <option hidden value="">
                      Select reason here
                    </option>
                    {reasons.map((item, index) => (
                      <option key={item?.id ?? `${item?.name}-${index}`} value={item?.name}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </li>
          </ul>
        </div>

        <ul className="ButtonList">
          <li>
            <button
              className="ModalCloseBtn"
              disabled={isSubmitting || showSkeleton}
              onClick={onSubmit}
              type="button"
            >
              {isSubmitting ? "Please wait..." : "Yes Cancel Appointment"}
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}
